import IconButton from "@material-ui/core/IconButton";
import { createStyles, Theme, withStyles, WithStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import React from "react";

const styles = (theme: Theme) =>
  createStyles({
    closeButton: {
      padding: theme.spacing(1),
      margin: `-${theme.spacing(1)}px 0`,
    },
    icon: {
      color: theme.palette.common.white,
      fontSize: 20,
    },
  });

interface SnackbarNotificationDismissButtonComponentProps extends WithStyles<typeof styles> {
  onClose: () => void;
}

export const SnackbarNotificationDismissButtonComponent = (props: SnackbarNotificationDismissButtonComponentProps) => {
  const { onClose, classes } = props;

  return (
    <IconButton key="close" aria-label="Close" color="inherit" className={classes.closeButton} onClick={onClose}>
      <CloseIcon className={classes.icon} />
    </IconButton>
  );
};

export const SnackbarNotificationDismissButton = withStyles(styles)(SnackbarNotificationDismissButtonComponent);
